function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'light', ultralight: 'ultralight', dark: 'dark', ultradark: 'ultradark' };
  const suffixe = suffixes[type];
  list.forEach(key => {
    res[`color-text-${key}${suffixe}`] = {
      color: theme.palette[key][type],
    };
    res[`color-background-${key}${suffixe}`] = {
      background: theme.palette[key][type],
    };
  });
}

export default theme => {
  const main = [
    'white',
    'black',
    'grey',
    'blue',
    'brown',
    'green',
    'khaki',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'yellow',
  ];
  const light = ['grey', 'red', 'green', 'blue', 'orange', 'purple', 'teal', 'yellow'];
  const ultralight = ['blue', 'green'];
  const dark = ['blue', 'green', 'khaki', 'pink', 'purple', 'red', 'teal'];
  const ultradark = ['red'];

  const res = {
    container: {
      display: 'grid',
      backgroundColor: theme.palette.white.main,
      gridTemplateColumns: '1fr 1fr',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    titleBlock: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    titleText: {
      flex: '4 1 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(8),
      '& > *:first-child': {
        paddingBottom: theme.spacing(2),
      },
      '@media (max-width:960px) and (max-height:720px)': {
        textAlign: 'center',
      },
    },
    title: {
      color: theme.palette.blue.main,
    },
    image: {
      flex: '6 1 0',
      width: '100%',
    },
    asideBlock: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: theme.spacing(4, 6, 6, 6),
      backgroundColor: theme.palette.blue.main,
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5),
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(3),
      },
    },
    desc: {
      padding: theme.spacing(8),
      display: 'flex',
      '& > *': {
        width: '100%',
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5),
        gap: theme.spacing(2),
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: theme.spacing(3),
        gap: theme.spacing(2),
      },
    },
    descLeft: {
      paddingRight: theme.spacing(4),
      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
      },
    },
    descRight: {
      paddingLeft: theme.spacing(4),
      '& > *:first-child': {
        paddingBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
      },
    },
  };

  loop(theme, res, ultralight, 'ultralight');
  loop(theme, res, light, 'light');
  loop(theme, res, main, 'main');
  loop(theme, res, dark, 'dark');
  loop(theme, res, ultradark, 'ultradark');

  return res;
};
